import { inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  isSupportedLocale,
  resolveLocale,
  setDocumentDirection,
  setLangToLocalStorage,
  SupportedLocale,
} from './locale';

@Injectable({ providedIn: 'root' })
export class I18nService {
  private readonly translateService = inject(TranslateService);

  readonly locales: ReadonlyArray<{ code: SupportedLocale; label: string }> = [
    { code: 'fr', label: 'COMMON.LANGUAGE.FR' },
    { code: 'en', label: 'COMMON.LANGUAGE.EN' },
    { code: 'ar', label: 'COMMON.LANGUAGE.AR' },
  ];
  readonly currentLocale = signal<SupportedLocale>(this.resolveCurrentLocale());

  switchLocale(locale: SupportedLocale): void {
    if (locale === this.currentLocale()) {
      return;
    }

    this.translateService.use(locale);
    setLangToLocalStorage(locale);
    setDocumentDirection(locale);
    this.currentLocale.set(locale);
  }

  private resolveCurrentLocale(): SupportedLocale {
    const currentLang = this.translateService.getCurrentLang();
    if (isSupportedLocale(currentLang)) {
      return currentLang;
    }

    return resolveLocale();
  }

  getLanguageLabel(locale: SupportedLocale): string {
    return this.locales.find(({ code }) => code === locale)?.label ?? 'COMMON.LANGUAGE.FR';
  }
}
